import { emailValidation } from '../../utils/validationUtils'

export default {
  userEmail: (value, _attributes) => emailValidation(value),
}
